import { Document } from '@aclass/admin/storage/models/document';
import { Opportunity } from '@aclass/admin/storage/models/opportunity';
import { Fk, Model } from '@aclass/core/decorators/orm.decorator';
import { Model as Entity } from 'redux-orm';

export interface IDocumentOpportunityMappingData {

    readonly documentId: Document | string | null;

    readonly enquireDataId: Opportunity | number | null;
}

@Model({
    name: 'DocumentOpportunityMapping',
    idAttribute: 'documentId'
})
export class DocumentOpportunityMapping extends Entity<IDocumentOpportunityMappingData> {

    @Fk({ to: 'Document', relatedName: 'relatedDocumentOpportunityMappings' }) readonly documentId: Document | null;

    @Fk({ to: 'Opportunity', relatedName: 'relatedDocumentOpportunityMappings' }) readonly enquireDataId: Opportunity | null;

}
